import { Button, Dialog, DialogActions, DialogBody, DialogSurface, DialogTitle } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useBlocker } from 'react-router';
import './Prompt.scss';

interface PromptProps {
  when: boolean;
}

const PromptImpl: React.FC<PromptProps> = (props) => {
  const {
    when,
  } = props;

  const blocker = useBlocker(
    when
      ? ({ currentLocation, nextLocation }) => {
        if (currentLocation.pathname !== nextLocation.pathname) {
          return true;
        }
        return false;
      }
      : false
  );

  const handleConfirm = (): void => {
    if (blocker.state === 'blocked') {
      blocker.proceed();
    }
  };

  const handleCancel = (): void => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  };

  return (
    <>
      {
        blocker.state === 'blocked' && (
          <Dialog
            open
          >
            <DialogSurface
              className='prompt'
            >
              <DialogBody>
                <DialogTitle>
                  Are you sure to leave this page? All unsaved changes will lost.
                </DialogTitle>
                <DialogActions>
                  <Button
                    appearance='primary'
                    onClick={() => handleConfirm()}
                  >
                    Proceed
                  </Button>
                  <Button
                    appearance='secondary'
                    onClick={() => handleCancel()}
                  >
                    Cancel
                  </Button>
                </DialogActions>
              </DialogBody>
            </DialogSurface>
          </Dialog>
        )
      }
    </>
  );
}

export const Prompt = observer(PromptImpl);